"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VARIANTS = exports.TYPES = exports.SIZES = exports.COLORS = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _loader = require("../loader");
var _Spinner, _Spinner2, _Spinner3;
const COLORS = exports.COLORS = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark', 'link'];
const VARIANTS = exports.VARIANTS = ['contained', 'outlined'];
const SIZES = exports.SIZES = ['xs', 'sm', 'lg'];
const TYPES = exports.TYPES = ['link', 'button', 'submit', 'reset'];
const Button = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  var _div, _div2;
  let {
    id,
    variant,
    color,
    size,
    type,
    link,
    target,
    rel,
    children,
    startIcon,
    endIcon,
    disabled,
    className,
    value,
    pending,
    onClick
  } = _ref;
  const showStartIcon = _react.default.useMemo(() => (0, _ark.isDefined)(startIcon), [startIcon]);
  const showEndIcon = _react.default.useMemo(() => (0, _ark.isDefined)(endIcon), [endIcon]);
  const showText = _react.default.useMemo(() => (0, _ark.isDefined)(children), [children]);
  const isTextMode = _react.default.useMemo(() => (0, _ark.isDefined)(children), [children]);
  const rootClassName = _react.default.useMemo(() => (0, _arkReact.concatClassName)('btn', variant != null && VARIANTS.includes(variant) ? `btn-${variant}` : null, color != null && COLORS.includes(color) ? `btn-${color}` : null, size != null && SIZES.includes(size) ? `btn-${size}` : null, isTextMode ? 'btn-text' : null, showStartIcon ? 'leftIcon' : null, showEndIcon ? 'rightIcon' : null, disabled ? 'btn-disabled' : null,
  // TODO: style this class
  className), [variant, color, showStartIcon, showEndIcon, isTextMode, className, disabled, size]);
  const click = _react.default.useCallback(event => {
    if ((0, _ark.isFunction)(onClick) && !disabled && !pending) onClick(event);
  }, [onClick, disabled, pending]);
  const btnIsDisable = disabled || pending;
  const renderContent = () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showStartIcon && (_div || (_div = /*#__PURE__*/_react.default.createElement("div", {
    className: "startIcon"
  }, startIcon))), showText && children, showEndIcon && (_div2 || (_div2 = /*#__PURE__*/_react.default.createElement("div", {
    className: "endIcon"
  }, endIcon))));
  const renderButton = () => {
    switch (type) {
      case 'submit':
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _arkReact.concatClassName)('btn-wrapper', pending ? 'btn-pending' : null)
        }, /*#__PURE__*/_react.default.createElement("input", {
          ref: ref,
          id: id,
          type: "submit",
          className: rootClassName,
          value: value,
          disabled: btnIsDisable,
          onClick: click
        }), pending === true && (_Spinner || (_Spinner = /*#__PURE__*/_react.default.createElement(_loader.Spinner, {
          className: "btn-spinner"
        }))));
      case 'link':
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _arkReact.concatClassName)('btn-wrapper', pending ? 'btn-pending' : null)
        }, disabled ? /*#__PURE__*/_react.default.createElement("a", {
          ref: ref,
          id: id,
          type: "button",
          className: rootClassName,
          href: "#"
        }, renderContent()) : /*#__PURE__*/_react.default.createElement("a", {
          ref: ref,
          id: id,
          type: "button",
          className: rootClassName,
          href: link,
          target: target,
          rel: rel
        }, renderContent()), pending === true && (_Spinner2 || (_Spinner2 = /*#__PURE__*/_react.default.createElement(_loader.Spinner, {
          className: "btn-spinner"
        }))));
      default:
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _arkReact.concatClassName)('btn-wrapper', pending ? 'btn-pending' : null)
        }, /*#__PURE__*/_react.default.createElement("button", {
          ref: ref,
          id: id,
          type: "button",
          className: rootClassName,
          disabled: btnIsDisable,
          onClick: click
        }, renderContent()), pending === true && (_Spinner3 || (_Spinner3 = /*#__PURE__*/_react.default.createElement(_loader.Spinner, {
          className: "btn-spinner"
        }))));
    }
  };
  return renderButton();
});
Button.displayName = 'Button';
process.env.NODE_ENV !== "production" ? Button.propTypes = {
  id: _propTypes.default.string,
  variant: _propTypes.default.oneOf(VARIANTS),
  color: _propTypes.default.oneOf(COLORS),
  size: _propTypes.default.oneOf(SIZES),
  type: _propTypes.default.oneOf(TYPES),
  link: _propTypes.default.string,
  target: _propTypes.default.string,
  rel: _propTypes.default.string,
  children: _propTypes.default.node,
  startIcon: _propTypes.default.node,
  endIcon: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string,
  value: _propTypes.default.string,
  pending: _propTypes.default.bool,
  onClick: _propTypes.default.func
} : void 0;
Button.defaultProps = {
  id: undefined,
  variant: undefined,
  color: undefined,
  size: undefined,
  type: undefined,
  link: undefined,
  target: undefined,
  rel: undefined,
  children: undefined,
  startIcon: undefined,
  endIcon: undefined,
  disabled: false,
  className: undefined,
  value: undefined,
  pending: false,
  onClick: undefined
};
var _default = exports.default = Button;